// Import directly from the core implementation to avoid circular deps
import { defineStore } from '@/plugins/pinia-core'
import { defaultParams } from '@/utils/constants'
import { getDeserializedCategoryProducts } from '@/utils/deserialization'

// We'll need these to access Nuxt's $axios
let $axios = null
let $nuxtContext = null

export const useBrandStore = defineStore('brand', {
  state: () => ({
    id: -1,
    breadcrumb: [],
    name: '',
    description: '',
    collapsedContent: '',
    products: [],
    meta: '',
  }),

  actions: {
    setBrand(brand) {
      this.breadcrumb = brand.breadcrumb
      this.id = brand.id
      this.meta = brand.meta
      this.name = brand.name
      this.description = brand.description
      this.collapsedContent = brand.collapsedContent
      this.products = [...brand.products]
    },

    async getBrand(brandId, { rootStore = null } = {}) {
      if (rootStore) {
        rootStore.removeError('brand')
        rootStore.addLoading('brand')
      }

      const couponCode = rootStore?.couponCode
      const params = { ...(couponCode && { couponCode }), ...defaultParams }

      try {
        const response = await $axios.get(`brand/${brandId}`, { params })
        const { data: brand } = response.data
        const { products } = brand
        const deserializedProducts = getDeserializedCategoryProducts(products)
        const deserializedBrand = { ...brand, products: deserializedProducts }

        this.setBrand(deserializedBrand)
      } catch (error) {
        if (error.response?.status === 404 && $nuxtContext) {
          $nuxtContext.error({ statusCode: 404, message: 'Brand not found' })
        } else if (error.response?.status === 401 && rootStore) {
          await rootStore.silentLogOut({ source: 'brand/getBrand' })

          try {
            const response = await $axios.get(`brand/${brandId}`, { params })
            const { data: brand } = response.data
            const { products } = brand
            const deserializedProducts = getDeserializedCategoryProducts(products)
            const deserializedBrand = { ...brand, products: deserializedProducts }

            this.setBrand(deserializedBrand)
          } catch (retryError) {
            if (rootStore) {
              rootStore.addError({ id: 'brand', error: retryError })
            }
          }
        }

        if (rootStore) {
          rootStore.addError({ id: 'brand', error })
        }
      } finally {
        if (rootStore) {
          rootStore.removeLoading('brand')
        }
      }
    },
  },
})

// Initialization function to provide Nuxt's axios to the store
export function initializeBrandStore(nuxtAxios, context) {
  $axios = nuxtAxios
  $nuxtContext = context
}
